import React from 'react'

import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { useAppSettings, useBrand } from 'components/shared/SettingsProvider'

const FlexibilityText = props => {
  const { enableReservationsByDay } = useAppSettings()
  const { marcomUrl } = useBrand()

  if (enableReservationsByDay) {
    return (
      <>
        <Typography paragraph>
          Families can reserve any number of camp days that work for their
          schedule—no need to book full weeks or consecutive dates. Once
          registered, you can reserve more camp days to your account at any time
          as long as space is available.
        </Typography>

        <Typography paragraph>
          If you have any questions, please reach out to your{' '}
          <Link
            underline='always'
            target='_blank'
            href={`${marcomUrl}/contact/`}
          >
            local team
          </Link>
          .
        </Typography>
      </>
    )
  }

  return (
    <>
      <Typography paragraph>
        Families can purchase any number of Day Passes to use any day we're open
        that camp session – no weekly reservations required (except in Boston
        per local city regulations*). Once registered, you can add more Day
        Passes to your account at any time.
      </Typography>

      <Typography variant='body2' paragraph>
        * Boston families should select and reserve any number of weeks you plan
        to attend camp for at least one day after making your purchase.
      </Typography>

      <Typography paragraph>
        If you have any questions, please reach out to your{' '}
        <Link
          underline='always'
          target='_blank'
          href='https://steveandkatescamp.com/contact/'
        >
          local team
        </Link>
        .
      </Typography>
    </>
  )
}

export default FlexibilityText
